import React from 'react';
import { Link } from 'react-router-dom';
import { COMPANY, FOOTER_LINKS } from '../data/content';

const Footer = () => {
  return (
    <footer className="relative border-t border-white/5 bg-[#030303] mt-32" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 pt-20 pb-10">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-10 mb-16">
          {/* Brand */}
          <div className="col-span-2">
            <Link to="/" className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 rounded-lg overflow-hidden bg-white">
                <img
                  src={COMPANY.logoUrl}
                  alt="Bronto Intelligence"
                  className="w-full h-full object-cover"
                />
              </div>
              <span className="text-lg font-bold rainbow-text">{COMPANY.displayName}</span>
            </Link>
            <p className="text-sm text-white/50 leading-relaxed max-w-md">
              {COMPANY.legalName} is an Indian technology company building artificial intelligence platforms, agricultural intelligence systems, space discovery experiences, and future digital technologies through BrontoAI, BrontoY, MSPConnect, and Bronto Cosmos.
            </p>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-xs font-semibold text-white/40 uppercase tracking-widest mb-5">Company</h4>
            <ul className="space-y-3">
              {FOOTER_LINKS.company.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-sm text-white/70 hover:text-white transition-colors"
                    data-testid={`footer-link-${link.name.toLowerCase().replace(/\s+/g, '-')}`}
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Platforms */}
          <div>
            <h4 className="text-xs font-semibold text-white/40 uppercase tracking-widest mb-5">Platforms</h4>
            <ul className="space-y-3">
              {FOOTER_LINKS.platforms.map((link) => (
                <li key={link.href}>
                  <Link to={link.href} className="text-sm text-white/70 hover:text-white transition-colors">
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-10 border-t border-white/5 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
          <p className="text-xs text-white/40">
            © {new Date().getFullYear()} {COMPANY.legalName}. All rights reserved.
          </p>
          <div className="flex flex-wrap items-center gap-6">
            {FOOTER_LINKS.legal.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className="text-xs text-white/40 hover:text-white/80 transition-colors"
              >
                {link.name}
              </Link>
            ))}
          </div>
        </div>

      </div>
    </footer>
  );
};

export default Footer;
